// v2/utils/discount.js
// B2B zincir indirim hesaplamaları.
// Zincir indirimler TOPLANMAZ, sırayla uygulanır:
//   1000 -> %20 -> 800 -> %5 -> 760 -> %4 -> 729,60

const toRate = (r) => {
  const n = Number(r);
  return Number.isFinite(n) ? n : 0;
};

/** Zincirin kalan fiyat çarpanı. %20+%5+%4 -> 0.7296 */
export function chainFactor(rates = []) {
  return rates.reduce((acc, r) => acc * (1 - toRate(r) / 100), 1);
}

/** Brüt fiyata zinciri uygular. Kuruşa yuvarlar. */
export function applyDiscountChain(grossPrice, rates = []) {
  const gross = Number(grossPrice);
  if (!Number.isFinite(gross)) return 0;
  return Math.round(gross * chainFactor(rates) * 100) / 100;
}

/** Efektif (gerçek) indirim oranı. %20+%5+%4 -> 27.04 */
export function effectiveDiscountRate(rates = []) {
  return Math.round((1 - chainFactor(rates)) * 10000) / 100;
}

/** Toplam kazanc (brut - net). */
export function discountAmount(grossPrice, rates = []) {
  const gross = Number(grossPrice);
  if (!Number.isFinite(gross)) return 0;
  return Math.round((gross - applyDiscountChain(gross, rates)) * 100) / 100;
}

/** Gosterim metni: [20,5,4] -> "%20 + %5 + %4" */
export function formatChain(rates = []) {
  if (!rates.length) return '-';
  return rates
    .map((r) => `%${String(toRate(r)).replace('.', ',')}`)
    .join(' + ');
}

/* ---- KDV ---- */
export const VAT_RATE = 20;

/** Net fiyata KDV ekler. */
export function withVat(net, rate = VAT_RATE) {
  const n = Number(net);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * (1 + rate / 100) * 100) / 100;
}

/**
 * Zinciri parcalara ayirir: grup indirimi mi, kampanya mi.
 * discounts: [{ rate, kind: 'group' | 'campaign' }]
 */
export function buildChain(groupRates = [], campaignRate = 0) {
  const parts = groupRates.map((r) => ({ rate: r, kind: 'group' }));
  if (campaignRate > 0) parts.push({ rate: campaignRate, kind: 'campaign' });
  return parts;
}

export const chainRates = (parts = []) => parts.map((p) => p.rate);
